import React, { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { ItemTypes } from './ItemTypes';
import { manualPath, errorpath } from '../fieldPath';
import { useCustomColumnState } from '../CustomColumnContextProvider';

const style = {
  cursor: 'move',
};
function RenderOptionsType({ column, index, moveTr, id, remove, addNew, handleChange, pIndex, wholeArry }) {
  const { globalError } = useCustomColumnState();
  const ref = useRef(null);
  const { t } = useTranslation('common');

  const [{ handlerId }, drop] = useDrop({
    accept: ItemTypes.CARD,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      moveTr(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.CARD,
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0.5 : 1;
  drag(drop(ref));
  return (
    <div className="mb-2 form-group d-flex" key={id} style={{ ...style, opacity }} data-handler-id={handlerId} ref={ref}>
      <div className=" mb-4 pt-0 input-group form-floating-label fixed-label">
        <input
          type="text"
          onChange={(e) => handleChange(e.target.value, manualPath(pIndex, '', index).MANUAL_OPTIONS_OBJECT)}
          placeholder={t('RANGE_PLANS.CUSTOM_SECTION.ADD_COLUMNS.RENDER_LABEL_TYPES.ENTER_OPTIONS')}
          value={column?.name}
          maxLength="30"
          className="form-control text-bordered h-35 "
        />

        <div className="text-count">{get(column, 'name', '').length}/30</div>
        <span className="error-message position-absolute top-32">{get(globalError, errorpath(pIndex, index).MANUAL_ERROR, '')}</span>
      </div>
      <button className="btn btn-outline m-0 ml-2" id={column?.name}>
        <span className="icon-expand" />
      </button>
      {wholeArry.length - 1 === index ? (
        <button className="btn btn-outline m-0 ml-2" onClick={addNew}>
          <span className="icon-add" />
        </button>
      ) : (
        <button className="btn btn-outline m-0 ml-2">
          <span className="icon-delete" onClick={() => remove(index)} />
        </button>
      )}
    </div>
  );
}

export default RenderOptionsType;
